// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"FullWidthText_moduleWrapper__P9W59"};